import { ELinks } from '../../util/constants';
import { Link as RouterLink } from 'react-router-dom';
import styles from './AlreadyHaveAccount.module.scss';
import GlobalContext from '../../contexts/GlobalContext';
import { FC, useContext } from 'react';
import { Link } from '@mui/material';

const AlreadyHaveAccount: FC = () => {
    const { language, consumerLoginLink, coBranding } = useContext(GlobalContext);
    return (
        <section
            className={`${styles.haveAccount} ${coBranding.brandColor && styles.coBranded} ${
                coBranding.isDarkMode && styles.darkMode
            }`}
        >
            <p>
                {language.createAccount.existingAccountDesc}{' '}
                {consumerLoginLink ? (
                    <Link component={RouterLink} to={consumerLoginLink}>
                        {language.createAccount.existingAccountCTA}
                    </Link>
                ) : (
                    <Link href={ELinks.userPortal}>{language.createAccount.existingAccountCTA}</Link>
                )}
            </p>
        </section>
    );
};

export default AlreadyHaveAccount;
